export default [
  {
    title: 'Tools',
    icon: 'ToolIcon',
    children: [
      {
        title: 'Filters',
        route: 'filter-list',
        resource: 'tool',
        action: 'read',
      },
      {
        title: 'Labels',
        route: 'label-list',
        resource: 'tool',
        action: 'read',
      },
      {
        title: 'Task Categories',
        route: 'process-category-list',
        resource: 'process-category',
        action: 'read',
      },
      {
        title: 'Settings',
        route: 'setting-list',
        resource: 'setting',
        action: 'read',
      },
    ],
  },
]
